import { switchBreakpoint } from './CurrentBreakpoint/action-creators';
import { Store } from './State';

// If changing these constants, change the Breakpoint enum in Avensia.Scope/Device/Breakpoints.cs the same way
export enum Breakpoint {
  Init = 0,
  Large = 1
}

const breakpointSettings = BREAKPOINT_SETTINGS;
const breakpointKeys = Object.keys(breakpointSettings) as Array<keyof typeof breakpointSettings>;

// If the breakpoint is MICRO (which is set to 320) the width is at minimum 320
// so you get the width for the next breakpoint (TINY) because the screen could be up til
// TINY
export function widthFromBreakpoint(breakpoint: number): number {
  if (breakpoint === 0) {
    return 0;
  }

  const name = breakpointKeys[breakpoint - 1];

  if (name) {
    return breakpointSettings[name];
  }

  if (process.env.NODE_ENV !== 'production') {
    throw new Error('Invalid breakpoint: ' + breakpoint);
  } else {
    return breakpointSettings[breakpointKeys[breakpointKeys.length - 1]];
  }
}

export function breakpointFromWidth(width: number) {
  for (let i = breakpointKeys.length; i > 0; i--) {
    if (breakpointSettings[breakpointKeys[i - 1]] <= width) {
      return i;
    }
  }
  return 0;
}

export function currentBreakpoint() {
  if (!__BROWSER__) {
    throw new Error('You cannot run `currentBreakpoint()` from the server');
  }

  return getBreakpoint();
}

const mediaQueries = __BROWSER__
  ? // We skip init here because we assume that it is if no media query matches
    breakpointKeys.map(breakpoint => window.matchMedia(`(min-width: ${breakpointSettings[breakpoint]}px)`))
  : [];

function getBreakpoint() {
  for (let i = mediaQueries.length; i > 0; i--) {
    if (mediaQueries[i - 1].matches) {
      return i;
    }
  }
  return 0;
}

export function setupResizeListener(store: Store) {
  let willSwitch = false;
  const triggerSwitch = () => {
    if (!willSwitch) {
      willSwitch = true;
      requestAnimationFrame(() => {
        store.dispatch(switchBreakpoint(getBreakpoint()));
        willSwitch = false;
      });
    }
  };

  for (const mediaQuery of mediaQueries) {
    mediaQuery.addListener(triggerSwitch);
  }
}
